import React, {Component, PropTypes} from 'react';
import {Icon, Badge, Menu, Dropdown, BackTop, message, Spin} from 'antd'
const MenuItem = Menu.Item;
import avatar from "../../../assets/common/img/avatar.png"
import logout from '../../../action/login/logout'
import {connect} from 'react-redux'
import SSpin from '../../../components/common/SSpin'

const navUrlMap = {
  index: ['/index/index.html'],
  organization: ['/organization/'],
  dashboard: ['/dashboard/', '/admin/', '/org/', '/permission/', '/leave/', '/recruitment/', '/telant/'],
  workflow: ['/workflow/'],
}

class Header extends Component {
  constructor(props) {
		super(props);
	}

  doLogout = (e) => {
		e.preventDefault();
		this.props.logout().then(({retCode, retMsg}) => {
      // 退出成功
			if (retCode === 0)
			{
				message.success('退出成功', 1, function () {
					location.href = '/login/login.html?redirectUrl=' + location.pathname + location.search;
				});
			}
		})
	}

  getNavClass = (key) => {
    const pathname = location.pathname
    const activePaths = navUrlMap[key] ? navUrlMap[key] : []
    const bool = activePaths.some(item => pathname.indexOf(item) > -1)
    if (bool) {
      return 'active'
    }
    else return ''
  }
  render() {
    const aStyle = {height:40,lineHeight:40 - 14 +'px'};
    const iconStyle = {fontSize:18,verticalAlign:'middle',height:18,lineHeight:'16px'}

    const menu = (
      <Menu style={{width:90,textAlign:'center',fontSize:14,marginTop:17}}>
        <MenuItem key="1" >
          <a href="/settings/index.html" style={aStyle}><Icon type="setting" style={iconStyle}/> 设置</a>
        </MenuItem>
        <MenuItem key="2">
          <a href="javascript:void(0);" onClick={this.doLogout}  style={aStyle}><Icon type="logout" style={{fontSize:15,marginTop:1}}/> 退出</a>
        </MenuItem>
      </Menu>
    )
    return (
      <div className="header-w">
        <ul className="header-nav">
          <li className="logo-c">
              <a href="/index/index.html" className="logo"></a>
          </li>
          <li className={this.getNavClass('index')}>
              <a href="/index/index.html">我的主页</a>
          </li>
          <li className={this.getNavClass('organization')}>
              <a href="/organization/index.html">企业文化</a>
          </li>
          <li className={this.getNavClass('workflow')}>
              <a href="/workflow/start.html">工作流程</a>
          </li>
          <li className={this.getNavClass('dashboard')}>
              <a href="/dashboard/index.html">功能入口</a>
          </li>
          
        </ul>
        <ul className="header-user">
          <li className="bell-c">
            <a href="javascript:;">
              <Badge className="msg" count={0} overflowCount={99} style={{ backgroundColor: '#FF8C00'}}>
                <Icon type="bell"/>
              </Badge>
            </a>
          </li>
          <li className="avatar-c">
            <a href="javascript:;" ><img src={avatar} alt=""/></a>
          </li>
          <li className="dropdown-c">
            <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
              <a className="ant-dropdown-link" href="#">
                <span className="ellipsis username-c">{this.props.user.realName} </span>
                <Icon type="down" />
              </a>
            </Dropdown>
          </li>
        </ul>
        <BackTop></BackTop>

        <SSpin/>
      </div>
    );
  }
}


const mapStateToProps = ({query, page}) => {
	return {
    query,
    showLoading: page.showLoading
  }
}

export default connect(mapStateToProps, {
	logout
})(Header);





// WEBPACK FOOTER //
// ./src/components/layout/header/index.js